import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelCheckbox as _vModelCheckbox, createElementVNode as _createElementVNode, withDirectives as _withDirectives, createTextVNode as _createTextVNode, unref as _unref, normalizeClass as _normalizeClass, createBlock as _createBlock, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, createVNode as _createVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "location-header"
}
const _hoisted_2 = {
  key: 0,
  class: "checkbox check-only-open"
}
const _hoisted_3 = ["src"]
const _hoisted_4 = { class: "app-progress" }
const _hoisted_5 = { class: "next" }
const _hoisted_6 = ["src"]
const _hoisted_7 = { style: {"margin-top":"-50px"} }
const _hoisted_8 = ["src"]
const _hoisted_9 = { class: "next" }
const _hoisted_10 = ["src"]
const _hoisted_11 = {
  key: 0,
  class: "checkbox check-only-open"
}
const _hoisted_12 = { class: "app-progress" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("div", { class: "title" }, "Offene Fragen", -1)
const _hoisted_14 = ["onClick"]

import {useStore} from "vuex";
import AppActivity from "@/components/AppActivity.vue";
import getDb from "@/db/Database";
import QuestionnaireRelease from "@/api/types/QuestionnaireRelease";
import ConfigurationEntity from "@/db/ConfigurationEntity";
import {ICON_BACK, ICON_CANCEL, ICON_LIST, ICON_NEXT, ICON_SAVE} from "@/lib/icons";
import {useRouter} from "vue-router";
import {computed, ref, watch} from "vue";
import UserQuestionnaire from "@/api/types/UserQuestionnaire";
import QuestionComponent from "@/components/question/QuestionComponent.vue";
import ProgressBar from "@/components/ProgressBar.vue";
import QuestionHandler, {QuestionEntry, RawAnswer} from "@/lib/QuestionHandler";
import {hideSpinner, showSpinner} from "@/store";
import Location from "@/api/types/Location";
import AppAlert from "@/components/AppAlert.vue";
import ResultScreen from "@/components/check/ResultScreen.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'CheckActivity',
  setup(__props) {

const icons = computed(() => {
  const res = [ICON_LIST]

  if (currentIndex.value >= 0) {
    res.push(ICON_SAVE)
  }

  res.push(ICON_CANCEL)
  return res
})

const store = useStore()
const router = useRouter()

const onIconAction = async (icon: string) => {
  switch (icon) {
    case ICON_LIST:
      showOpenQuestionsModal.value = true
      break
    case ICON_SAVE:
      if (currentIndex.value >= 0) {
        await handler.saveAnswer(currentIndex.value, rawAnswer.value)
      }
      await store.dispatch('SAVE_QUESTIONNAIRE')
      await router.push({ name: 'questionnaire', params: { mode: 'check' } })
      break
    case ICON_CANCEL:
      handler.clear()
      await router.push({ name: 'menu' })
      break
  }
}

const handler = new QuestionHandler(store, getDb())

const showOnlyOpenQuestions = ref<boolean>(false)

const rawAnswer = ref<RawAnswer>(null)

const categoryFilter = store.state.check.categoryFilter
const currentRelease: QuestionnaireRelease = store.state.currentRelease
const currentQuestionnaire: UserQuestionnaire = store.state.currentQuestionnaire

const currentLocation = ref<Location|null>(store.getters.selectedLocation)

const globalQuestions = computed(() => store.state.check.questions)
const openQuestions = ref([])

const currentIndex = computed<number>(() => store.state.check.questionIndex)
const currentQuestion = ref<QuestionEntry>()

const showOpenQuestionsModal = ref<boolean>(false)

const prevIndex = ref<number>(-1)
const nextIndex = ref<number>(-1)

const progress = ref<number>(0)

const isResultPage = computed(() => currentIndex.value === -1)

const prevQuestion = async () => {
  if (prevIndex.value >= 0) {
    if (currentIndex.value >= 0) {
      await handler.saveAnswer(currentIndex.value, rawAnswer.value)
    }
    const { prev, next } = detectNeighbors()
    store.commit('check/SET_QUESTION_INDEX', prev)
  }
}

const nextQuestion = async () => {
  if (nextIndex.value >= 0) {
    await handler.saveAnswer(currentIndex.value, rawAnswer.value)
    const { prev, next } = detectNeighbors()
    store.commit('check/SET_QUESTION_INDEX', next)
  } else {
    showOnlyOpenQuestions.value = false
    await handler.saveAnswer(currentIndex.value, rawAnswer.value)
    store.commit('check/SET_QUESTION_INDEX', -1)
  }
}

const load = async () => {
  const configuration = await ConfigurationEntity.get(getDb())

  if (configuration) {
    showSpinner()
    await handler.loadQuestions(
        <number>currentRelease.questionnaireId,
        <number>currentQuestionnaire.pk,
        configuration.user,
        categoryFilter)
    hideSpinner()
  }
}

const calculateProgress = () => {
  let answered = 0
  let count = 0

  for (const question of store.state.check.questions) {
    if (question.displayed) {
      count++
      const uq = question.userQuestion
      if (uq?.answers?.length || uq?.stringValue || uq?.numberValue || uq?.dateValue) {
        answered++
      }
    }
  }

  progress.value = count
      ? Math.round(answered * 100 / count)
      : 0

  if (progress.value === 100) {
    handler.setCompleted()
  }
}

const ignoreIfAnswered = ((question: any, ignoreShowOnlyOpenQuestions: boolean = false) => {
  if (question && question.userQuestion && (ignoreShowOnlyOpenQuestions || showOnlyOpenQuestions.value)) {
    const q = question.userQuestion
    return (q.stringValue || q.numberValue || q.dateValue || q.answers?.length)
  }
  return false
})

const getLastQuestionIndex = (): number => {
  return globalQuestions.value.length
}

const detectNeighbors = (): { prev: number, next: number } => {
  currentQuestion.value = globalQuestions.value[currentIndex.value]

  let prevIndexNum = currentIndex.value >= 0 ? currentIndex.value : getLastQuestionIndex()
  do {
    prevIndexNum --
  } while (prevIndexNum >= 0 && (typeof globalQuestions.value[prevIndexNum] === 'undefined' || !globalQuestions.value[prevIndexNum].displayed || ignoreIfAnswered(globalQuestions.value[prevIndexNum])))

  let nextIndexNum = currentIndex.value >= 0 ? currentIndex.value : getLastQuestionIndex()
  do {
    nextIndexNum ++
    if (typeof globalQuestions.value[nextIndexNum] === 'undefined') {
      nextIndexNum = -1
      break
    }
  } while (globalQuestions.value[nextIndexNum] && (!globalQuestions.value[nextIndexNum].displayed || ignoreIfAnswered(globalQuestions.value[nextIndexNum])))

  return {
    prev: prevIndexNum >= 0 ? prevIndexNum : -1,
    next: typeof globalQuestions.value[nextIndexNum] !== 'undefined' ? nextIndexNum : -1
  }
}

watch(() => ({ index: currentIndex.value, globalQuestions, showOnlyOpenQuestions: showOnlyOpenQuestions.value  }), () => {
  const { prev, next } = detectNeighbors()

  openQuestions.value = globalQuestions.value
      .filter((q: any) => !ignoreIfAnswered(q, true))
      .filter((q: any) => q.displayed)

  prevIndex.value = prev
  nextIndex.value = next

  calculateProgress()
}, { immediate: true, deep: true })

const gotoQuestion = async (id: number) => {
  const index = globalQuestions.value.findIndex((q: any) => q.id === id)
  if (index >= 0) {
    await handler.saveAnswer(currentIndex.value, rawAnswer.value)
    store.commit('check/SET_QUESTION_INDEX', index)
    showOpenQuestionsModal.value = false
  }
}

load()

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(AppActivity, {
    title: "Risiko - Analyse",
    icons: icons.value,
    onIconClick: onIconAction,
    id: "check-activity"
  }, {
    footer: _withCtx(() => [
      (currentIndex.value >= 0)
        ? (_openBlock(), _createElementBlock("label", _hoisted_11, [
            _withDirectives(_createElementVNode("input", {
              type: "checkbox",
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((showOnlyOpenQuestions).value = $event))
            }, null, 512), [
              [_vModelCheckbox, showOnlyOpenQuestions.value]
            ]),
            _createTextVNode(" Nur unbeantwortete Fragen anzeigen ")
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("nav", null, [
        _createElementVNode("div", _hoisted_12, [
          (currentIndex.value >= 0)
            ? (_openBlock(), _createBlock(ProgressBar, {
                key: 0,
                modelValue: progress.value,
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((progress).value = $event))
              }, null, 8, ["modelValue"]))
            : _createCommentVNode("", true)
        ])
      ])
    ]),
    default: _withCtx(() => [
      (currentIndex.value >= 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, _toDisplayString(`${currentLocation.value.name} - ${currentLocation.value.registrationNr}`), 1))
        : _createCommentVNode("", true),
      (currentIndex.value < 0)
        ? (_openBlock(), _createBlock(ResultScreen, {
            key: 1,
            completed: progress.value === 100
          }, {
            navigation: _withCtx(() => [
              (currentIndex.value >= 0)
                ? (_openBlock(), _createElementBlock("label", _hoisted_2, [
                    _withDirectives(_createElementVNode("input", {
                      type: "checkbox",
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((showOnlyOpenQuestions).value = $event))
                    }, null, 512), [
                      [_vModelCheckbox, showOnlyOpenQuestions.value]
                    ]),
                    _createTextVNode(" Nur unbeantwortete Fragen anzeigen ")
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("nav", null, [
                _createElementVNode("div", {
                  class: _normalizeClass(["prev", { disabled: prevIndex.value < 0 && currentIndex.value >= 0 }])
                }, [
                  _createElementVNode("a", {
                    href: "javascript:void(0)",
                    onClick: prevQuestion
                  }, [
                    _createElementVNode("img", { src: _unref(ICON_BACK) }, null, 8, _hoisted_3)
                  ])
                ], 2),
                _createElementVNode("div", _hoisted_4, [
                  (currentIndex.value >= 0)
                    ? (_openBlock(), _createBlock(ProgressBar, {
                        key: 0,
                        modelValue: progress.value,
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((progress).value = $event))
                      }, null, 8, ["modelValue"]))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", _hoisted_5, [
                  (currentIndex.value >= 0)
                    ? (_openBlock(), _createElementBlock("a", {
                        key: 0,
                        href: "javascript:void(0)",
                        onClick: nextQuestion
                      }, [
                        _createElementVNode("img", { src: _unref(ICON_NEXT) }, null, 8, _hoisted_6)
                      ]))
                    : _createCommentVNode("", true)
                ])
              ])
            ]),
            _: 1
          }, 8, ["completed"]))
        : _createCommentVNode("", true),
      (currentQuestion.value)
        ? (_openBlock(), _createBlock(QuestionComponent, {
            key: 2,
            question: currentQuestion.value,
            modelValue: rawAnswer.value,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((rawAnswer).value = $event))
          }, {
            navigation: _withCtx(() => [
              _createElementVNode("nav", _hoisted_7, [
                _createElementVNode("div", {
                  class: _normalizeClass(["prev", { disabled: prevIndex.value < 0 && currentIndex.value >= 0 }])
                }, [
                  _createElementVNode("a", {
                    href: "javascript:void(0)",
                    onClick: prevQuestion
                  }, [
                    _createElementVNode("img", { src: _unref(ICON_BACK) }, null, 8, _hoisted_8)
                  ])
                ], 2),
                _createElementVNode("div", _hoisted_9, [
                  (currentIndex.value >= 0)
                    ? (_openBlock(), _createElementBlock("a", {
                        key: 0,
                        href: "javascript:void(0)",
                        onClick: nextQuestion
                      }, [
                        _createElementVNode("img", { src: _unref(ICON_NEXT) }, null, 8, _hoisted_10)
                      ]))
                    : _createCommentVNode("", true)
                ])
              ])
            ]),
            _: 1
          }, 8, ["question", "modelValue"]))
        : _createCommentVNode("", true),
      _createVNode(AppAlert, {
        show: showOpenQuestionsModal.value,
        title: "Offene Fragen",
        class: "open-questions-alert",
        onOk: _cache[5] || (_cache[5] = () => showOpenQuestionsModal.value = false)
      }, {
        default: _withCtx(() => [
          _hoisted_13,
          _createElementVNode("ul", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(openQuestions.value, (question) => {
              return (_openBlock(), _createElementBlock("li", {
                key: question.id,
                onClick: () => gotoQuestion(question.id)
              }, " Frage " + _toDisplayString(question.numberString), 9, _hoisted_14))
            }), 128))
          ])
        ]),
        _: 1
      }, 8, ["show"])
    ]),
    _: 1
  }, 8, ["icons"]))
}
}

})